"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSetInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class DataSetInternalApi extends ApiBase_1.ApiBase {
    /**
     * Fires the DataSet Selected Event
     * @param dataSet Data Set which has been selected
     */
    fireDataSetSelectedEvent(dataSet) {
        if (this.adaptable.isLive) {
            const dataSetSelectedInfo = {
                adaptableApi: this.adaptable.api,
                dataSet, userName: this.adaptable.api.optionsApi.getUserName(),
                adaptableId: this.adaptable.api.optionsApi.getAdaptableId(),
            };
            this.adaptable.api.eventApi.emit('DataSetSelected', dataSetSelectedInfo);
        }
    }
}
exports.DataSetInternalApi = DataSetInternalApi;
